export default function MySQL_TIME() {
  return (
    <div>
      <h2>MySQL_TIME</h2>    </div>
  );
}